export enum InteractionStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type InteractionDictionary = {
  id: number;
  name: string;
};

export type InteractionTheme = {
  id: number;
  name: string;
  image: string;
};

export type Campaign = {
  id: number;
  name: string;
  campaign_id: number;
  campaign_name: string;
};

export type Interaction = {
  id: number;
  name: string;
  status: InteractionStatusEnum;
  created_at: string;
  updated_at: string;
  interaction_dictionary: InteractionDictionary;
};

export type InteractionDetails = {
  id: number;
  name: string;
  with_leaderboard: boolean;
  with_pvo: boolean;
  with_pvo_form: boolean;
  language: string;
  status: InteractionStatusEnum;
  created_at: string;
  updated_at: string;
  interaction_dictionary: InteractionDictionary;
  selected_theme_id?: number;
  themes: InteractionTheme[];
  campaigns: Campaign[];
};

export type AddInteractionRequest = {
  name: string;
  with_leaderboard: boolean;
  with_pvo: boolean;
  with_pvo_form: boolean;
  language: string;
  status: InteractionStatusEnum;
  interaction_dictionary_id: number;
  selected_theme_id: number;
};

export type EditInteractionRequest = {
  name?: string;
  with_leaderboard?: boolean;
  with_pvo?: boolean;
  with_pvo_form?: boolean;
  language?: string;
  status?: InteractionStatusEnum;
  selected_theme_id?: number;
};
